import Vue from "vue";

export const instance = new Vue({ name: "notification" });
